module.exports = __webpack_public_path__ + "img/rg-target-vessel-caution-default.f2f8dc86.svg";